import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useResolvedTheme } from '../../theme/useThemeMode';

/**
 * The single toast outlet. `toast()` from `@opengoal/ui` works anywhere once
 * this is mounted — `ThemeProvider` mounts it — and follows the resolved theme
 * rather than the OS, so a dark-mode user who forced light gets light toasts.
 */
function Toaster(props: ToasterProps) {
  const theme = useResolvedTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      richColors={false}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      toastOptions={{ classNames: { toast: 'font-sans text-sm' } }}
      {...props}
    />
  );
}

export { Toaster };
